import { config } from '@/config'
import { getRequestOptions, postRequestOptions } from '@/utils/auth-headers'
import { authService } from '@/services/AuthService'

export const userService = {
  getAll,
  getCurrent,
  getStratumInfo,
  update,
  addUser,
  getDayHashrate,
  refreshStat,
  refreshStat10,
  resetPassword,
  changePassword,
  getWatchers,
  deleteWatcher,
  addWatcher,
  getUserTags
}

function getAll () {
  return fetch(config.api.user.users, getRequestOptions()).then(authService.handleResponse)
}

function getCurrent () {
  return fetch(config.api.user.current, getRequestOptions()).then(authService.handleResponse)
}

function getStratumInfo () {
  return fetch(config.api.user.stratumInfo, getRequestOptions()).then(authService.handleResponse)
}

function update (user) {
  return fetch(config.api.user.update, postRequestOptions(user)).then(authService.handleResponse)
}

function addUser (user) {
  return fetch(config.api.user.add, postRequestOptions(user)).then(authService.handleResponse)
}

function getDayHashrate (body) {
  return fetch(config.api.user.dayHashrate, postRequestOptions(body)).then(authService.handleResponse)
}

function refreshStat () {
  return fetch(config.api.user.refreshStat, getRequestOptions()).then(authService.handleResponse)
}

function refreshStat10 () {
  return fetch(config.api.user.refreshStat10, getRequestOptions()).then(authService.handleResponse)
}

function resetPassword (body) {
  return fetch(config.api.user.resetPassword, postRequestOptions(body)).then(authService.handleResponse)
}

function changePassword (body) {
  return fetch(config.api.user.changePassword, postRequestOptions(body)).then(authService.handleResponse)
}

function getWatchers (body) {
  const userId = body && body.id
  const url = userId != null
    ? `${config.api.user.watchers}?id=${encodeURIComponent(userId)}`
    : config.api.user.watchers
  return fetch(url, getRequestOptions()).then(authService.handleResponse)
}

function deleteWatcher (body) {
  return fetch(config.api.user.deleteWatcher, postRequestOptions(body)).then(authService.handleResponse)
}

function addWatcher (body) {
  return fetch(config.api.user.addWatcher, postRequestOptions(body)).then(authService.handleResponse)
}

function getUserTags (id) {
  return fetch(config.api.user.users + '/' + id + '/tags', getRequestOptions()).then(authService.handleResponse)
}
